import Header from "@shared/components/Atoms/Contents/Header";
import FooterMain from "@shared/components/Atoms/Contents/FooterMain";
import { FOOTER } from "@shared/util/brand";

const Terms = () => {
  const supportEmail = FOOTER.email || "agent@videobrief.ai";
  return (
    <div>
      <Header />
      <div id="terms-page" className={``}>
        <div className="container mx-auto px-4 py-8">
          <div className="page-header flex justify-between items-center mb-6 mt-[60px]">
            {/* <h1 className="text-3xl font-bold">Terms of Service</h1>
            <button
              className="back-btn text-blue-600 hover:underline"
              onClick={() => window.history.back()}
            >
              ← Back
            </button> */}
          </div>

          <div className="max-w-4xl mx-auto my-10 p-8 rounded-xl">
            <h1 className="text-4xl font-bold text-gray-900 mb-6">
              Terms of Service
            </h1>
            <p className="text-gray-700 mb-6">
              <strong>Last Updated:</strong> July 24, 2025
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">
              1. By using our service, you agree to these terms.
            </h2>
            <p className="text-gray-700 mb-4">
              By accessing and using our SaaS platform ("Service"), you agree to
              be bound by these Terms of Service ("Terms"). If you disagree with
              any part of these terms, you may not access the Service.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">
              2. What we do
            </h2>
            <p className="text-gray-700 mb-4">
              We provide a platform for hosting and managing video content.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">
              3. Your account
            </h2>
            <p className="text-gray-700 mb-4">
              Keep your login info safe. You're responsible for what happens on
              your account.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">
              4. Content guidelines
            </h2>
            <p className="text-gray-700 mb-2">Please don't upload:</p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Illegal content</li>
              <li>Pornographic material</li>
              <li>Violent content</li>
              <li>Anything that breaks the law</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">
              5. Pricing
            </h2>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>1-day free trial (1 video)</li>
              <li>Billed monthly or annually</li>
              <li>Cancel anytime</li>
              <li>
                No refunds (but you keep access until your billing period ends)
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">
              6. Service rights
            </h2>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>We can refuse or terminate service to anyone</li>
              <li>We can modify or discontinue features at any time</li>
              <li>No explanation required</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">
              7. Intellectual property
            </h2>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Our platform and its features belong to us</li>
              <li>Your content remains yours</li>
              <li>Don't copy or redistribute our software</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">
              8. Privacy
            </h2>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>We respect your privacy</li>
              <li>See our Privacy Policy for details</li>
              <li>We don't sell your data</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">
              9. Liability
            </h2>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>We provide the service "as is"</li>
              <li>We're not responsible for lost data or profits</li>
              <li>Our liability is limited to what you paid us</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">
              10. Legal stuff
            </h2>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>California law applies</li>
              <li>Any disputes are handled in California</li>
              <li>These terms are the complete agreement</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">
              11. Changes to terms
            </h2>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>We can make changes to terms at any time</li>
              <li>Continued use means you accept new terms</li>
              <li>Check back occasionally for updates</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-2">
              12. Contact us
            </h2>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>
                Email:{" "}
                <a
                  href={`mailto:${supportEmail}`}
                  className="text-gray-800 underline"
                >
                  {supportEmail}
                </a>
              </li>
              <li>We typically respond within 2 business days</li>
              <li>Include your account email when contacting us</li>
            </ul>
          </div>
        </div>
      </div>
      <FooterMain />
    </div>
  );
};

export default Terms;
